module.exports = __webpack_public_path__ + "img/styles_background_desktop.206199a.jpg";